<template>
    <div class="tableIngresos">
        <vs-row>
            <vs-col w="12">
                <vs-input v-if="users != ''" class="ml-auto searchWidth" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
                <div class="d-flex justify-content-around mb-3" style="flex-flow: row wrap;">
                    <vs-button
                        v-if="users != ''"
                        color="#55ce63"
                        relief
                        :active="active == 5"
                        :loading="loadingExcel"
                        @click="active = 5, getInfoIngreso()"
                    >
                        <i class="fas fa-download mr-2"></i> Descargar reporte
                    </vs-button>
                    <vs-button
                        v-if="users != ''"
                        :disabled="selected.length == 0"
                        color="#FF4757"
                        relief
                        @click="restablecerGenerarCargos()"
                    >
                        <i class="fas fa-download mr-2"></i> Restablecer y Generar cargos
                    </vs-button>
                    <vs-button
                        v-if="users != ''"
                        :disabled="selected.length == 0"
                        color="#F9860C"
                        relief
                        @click="getRestablecerCargos()"
                    >
                        <i class="fas fa-download mr-2"></i> Restablecer cargos
                    </vs-button>
                    <vs-button
                        v-if="users != '' && enTiempo.includes('2')"
                        :disabled="sendVencida || selected.length == 0"
                        warn
                        relief
                        @click="getActiveModal('invitacion')"
                    >
                        <i class="fas fa-file-invoice-dollar mr-2"></i> Enviar carta de invitacion de pago
                    </vs-button>
                    <vs-button
                        v-if="users != '' && enTiempo.includes('2')"
                        :disabled="sendVencida || selected.length == 0"
                        color="#A569BD"
                        relief
                        @click="getActiveModal('suspencion')"
                    >
                        <i class="fas fa-user-clock mr-2"></i> Enviar carta de suspensión
                    </vs-button>
                </div>
                <div style="max-width: 100%">
                    <h5 v-if="infoCard.alumnosTotal">Número total de alumnos: <strong>{{ totalAlumnos}}</strong></h5>
                     <vs-table
                        v-model="selected"
                        v-dragscroll="{ target: '.vs-table', active: true }"
                        >
                        <template #thead>
                        <vs-tr>
                            <vs-th style="width: 50px !important; ">
                            <vs-checkbox
                                :indeterminate="selected.length == users.length" v-model="allCheck"
                                @change="selected = $vs.checkAll(selected, users)"
                            />
                            </vs-th>
                            <vs-th sort @click="users = $vs.sortData($event ,users, 'nombre')">
                                Alumno
                            </vs-th>
                            <vs-th>
                                Académico
                            </vs-th>
                            <vs-th>
                                Código de detalle
                            </vs-th>
                            <vs-th>
                                Fuente
                            </vs-th>
                            <vs-th>
                                Monto
                            </vs-th>
                            <vs-th>
                                Saldo pendiente
                            </vs-th>
                            <vs-th>
                                Fecha
                            </vs-th>
                            <vs-th>
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in $vs.getSearch(users, search)"
                            :data="tr"
                            :is-selected="!!selected.includes(tr)"
                            style="vertical-align: top;"
                        >
                            <vs-td v-if="cargosTotales[i] > 0" checkbox>
                                <vs-checkbox :val="tr" v-model="selected" v-if="tr.programa"/>
                            </vs-td>
                            <vs-td v-if="cargosTotales[i] > 0">
                                <md-content class="cienCincuenta d-block">
                                    <div class="estatus-alumno mb-2" :class="coloresEstatus(tr.estatus_registro_academico)" v-if="tr.estatus_registro_academico">
                                        <small><strong>{{tr.estatus_registro_academico}}</strong></small>
                                    </div>
                                    <div class="d-flex">
                                       <div>
                                            <vs-tooltip>
                                                <vs-avatar circle size="50">
                                                    <img :src="'/api/personas/' + tr.persona_id + '/avatar'" @error="setAltImg" alt="">
                                                        <template #badge>
                                                            {{cargosTotales[i]}}
                                                        </template>
                                                </vs-avatar>
                                                    <template #tooltip>
                                                        Número total de cargos: <strong> {{cargosTotales[i]}}</strong>
                                                    </template>
                                            </vs-tooltip>
                                        </div>
                                        <div class="ml-2">
                                            <strong>{{ tr.nombre }}</strong>
                                            <span style="text-transform: uppercase; font-size: 11px;">Matrícula</span>
                                            <strong>{{ tr.matricula }}</strong>
                                            <div class="mt-2">
                                                <md-menu md-size="small" md-align-trigger :md-offset-x="-70">
                                                    <vs-button
                                                        color="dark"
                                                        border
                                                        class="m-auto"
                                                        md-menu-trigger
                                                    >
                                                    <i class="fas fa-ellipsis-v mr-1"></i> Acciones
                                                    </vs-button>

                                                    <md-menu-content>
                                                        <md-menu-item v-if="cargosTotales[i] > 0" target="_blank" :href="'/estado-de-cuenta/' + tr.persona_id + '/gestion?institucion_id=' + institucion + '&ciclo_escolar_id=' + cicloEscolar">Gestión de finanzas</md-menu-item>
                                                        <md-menu-item v-if="JSON.parse(personaRol).tipoUserPrincipal = 'Personal central - TI'"  target="_blank" :href="`/panel/alumno/${tr.estadoCuenta}/institucion/${window.btoa(institucion)}?valor=ver-finanzas-alumno`">Finanzas</md-menu-item>
                                                        <md-menu-item v-if="JSON.parse(personaRol).tipoUserPrincipal = 'Personal central - TI'" @click="activeSeguimientoCobranza =! activeSeguimientoCobranza, selectRow = tr">Seguimiento de cobranza</md-menu-item>
                                                    </md-menu-content>
                                                </md-menu>
                                            </div>
                                        </div> 
                                    </div>
                                    
                                </md-content>
                            </vs-td>
                            <vs-td v-if="cargosTotales[i] > 0">
                                <md-content class="cienCincuenta d-block">
                                    <p class="mb-0"><small>PROGRAMA</small></p>
                                    <p><strong>{{ tr.programa }}</strong></p>
                                    <p class="mb-0"><small>CICLO ESCOLAR</small></p>
                                    <p><strong>{{tr.cicloEscolar}}</strong></p>
                                    <p class="mb-0"><small>GRUPO</small></p>
                                    <p><strong>{{tr.grupo}}</strong></p>
                                </md-content>
                            </vs-td>
                            <vs-td v-if="cargosTotales[i] > 0">
                                <md-content class="trecientos d-block" v-for="info in tr.cargos" :key="info.id" >
                                    <p class="mb-0"><strong>{{ info.codigoDetalle }}</strong> </p>
                                    <p class="mb-0"><small>SUBCATEGORÍA</small></p>
                                    <p class="mb-0"><strong>{{info.subcategoria}}</strong></p>
                                </md-content>
                            </vs-td>
                            <vs-td v-if="cargosTotales[i] > 0">
                                <md-content class="cienCincuenta" v-for="info in tr.cargos" :key="info.id">
                                   <p> {{ info.fuente }} </p>
                                </md-content>
                            </vs-td>
                            <vs-td v-if="cargosTotales[i] > 0">
                                <md-content class="cien" v-for="info in tr.cargos" :key="info.id">
                                    <p> {{ info.monto | currency }}</p>
                                </md-content>
                            </vs-td>
                            <vs-td v-if="cargosTotales[i] > 0">
                                <md-content class="cien" v-for="info in tr.cargos" :key="info.id">
                                    <p> {{ info.saldoPendiente | currency }}</p>
                                </md-content>
                                <p>Total: <strong>{{sumaTotal[i] | currency}}</strong></p>
                            </vs-td>
                            <vs-td v-if="cargosTotales[i] > 0">
                                <md-content class="docientos" v-for="info in tr.cargos" :key="info.id">
                                    <md-chip  v-if="info.saldoPendiente != 0 && info.fecha.vencida == true " class="mb-1 fontMedium mini-chip" :class="getColorMetodo(true)">
                                        Vencida <!-- 2 -->
                                        <strong>
                                            <span>{{ info.fecha.fechaVencimiento }}</span>
                                        </strong>
                                    </md-chip>
                                    <md-chip  v-if="info.saldoPendiente != 0 && info.fecha.vencida == false " class="mb-1 fontMedium mini-chip" :class="getColorMetodo(false)">
                                        En tiempo <!-- 1 -->
                                        <strong>
                                            <span>{{ info.fecha.fechaVencimiento }}</span>
                                        </strong>
                                    </md-chip>
                                    <md-chip  v-if="info.saldoPendiente == 0 " class="mb-1 fontMedium mini-chip" :class="getColorMetodo('cero')">
                                        <strong>
                                            <span>Aplicada <!-- 3 --></span>
                                        </strong>
                                    </md-chip>
                                </md-content>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
            </vs-col>
        </vs-row>
        <!-- <modal-restablecer v-model="activeRestablecer" :selected="selected" :cicloEscolar="cicloEscolar" :institucion="institucion"></modal-restablecer> -->
        <enviar v-model="activeEnviar" :vencidas="vencidas" :tipo="tipo" @sinRegistro="getSinRegistro"></enviar>
        <seguimiento-cobranza v-model="activeSeguimientoCobranza" :selectRow="selectRow"></seguimiento-cobranza>
        <alumno-sin-registro v-model="activeSinRegistro" :alumnosSinRegistro="alumnosSinRegistro"></alumno-sin-registro>
    </div>
</template>

<script>
import cobranza from '../../../../api/requests/cobranza-persona'
import axios from 'axios'
import { dragscroll } from 'vue-dragscroll'
import reportes from '../../../../api/requests/reportes.js'
import profesor from '../../../../api/requests/landing-profesor'
import ModalRestablecer from '../modales/reporte-cargos.vue'
import enviar from './modal/enviar.vue'
import alumnos from '../../../../api/requests/alumno'
import SeguimientoCobranza from './modal/seguimiento-cobranza.vue'
import AlumnoSinRegistro from './modal/alumnos_sin_registro.vue'
export default {
    props:[
        'users',
        'cicloEscolar',
        'institucion',
        'ciclosEscolares',
        'instituciones',
        'filtros',
        'sumaTotal',
        'infoCard',
        'enTiempo',
        'personaRol'
    ],
    data(){
        return{
            allCheck: false,
            selected: [],
            search: '',
            active: 0,
            statusColores: {
                "Facturado" : "green",
                "No facturado": "red"
            },
            colorFactura: {
                "false": "yellow",
                "true": "red",
                "cero": 'green'
            },
            loadingExcel: false,
            activeRestablecer: false,
            activeRegPago: true,
            programa: [],
            programas: [],
            programaId: (new Date()).getTime(),
            programaAssign: [],
            cargosTotales: [],
            totalAlumnos: '',
            sendVencida: true,
            vencidas: [],
            activeEnviar: false,
            tipo: [],
            estatusBaja: [],
            activeSeguimientoCobranza: false,
            selectRow: {},
            activeSinRegistro: false,
            alumnosSinRegistro: {}
        }
    },
    components:{
        ModalRestablecer,
        enviar,
        SeguimientoCobranza,
        AlumnoSinRegistro
    },
    directives: {
       'dragscroll': dragscroll
    },
    created(){
        this.getEstatusAlumno()
    },
    methods: {
        getSinRegistro(info){
            this.activeSinRegistro =! this.activeSinRegistro
            this.alumnosSinRegistro = info
        },
        async getEstatusAlumno(){
            try{
                const params = {
                    type: 'baja'
                }
                const {data: response} = await alumnos.getEstatusAlumno(params)
                response.map(r =>{
                    this.estatusBaja.push(r.status)
                })
            }catch(error){
                console.error(error)
            }
        },
        coloresEstatus(estatus){
            if(['Inscrito económico','Reactivación'].includes(estatus)){
                return 'col-green'
            }else if(['Congelado'].includes(estatus)){
                return 'col-yellow'
            }else if(this.estatusBaja.includes(estatus)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        assignPrograma(estadoCuenta, program,i){
            this.programaAssign[i] = {
                id: estadoCuenta,
                programa: program
            }
        },
        getNumeroTotal(){

            this.cargosTotales = [];
            this.users.forEach(i => {
                const datos = Object.values(i.cargos)
                const suma = datos.length
                this.cargosTotales.push(suma)
            })
        },
        getRestaTotal(){
            let resta =0;
            this.users.forEach(i => {
                const datos = Object.values(i.cargos)
                if (datos != ''){
                    resta = resta + 1;
                }
            })
            this.totalAlumnos = resta
        },
        async restablecerGenerarCargos(){
            const vue = this
            const loading = this.$vs.loading()
            try{
                if(this.selected[0]){
                    let datos = []
                    for(var x = 0;x < this.selected.length; x++){
                        var obj = {}
                        obj = {
                        id : atob(this.selected[x].estadoCuenta),
                        ciclo_escolar: this.cicloEscolar,
                        institucion: this.institucion,
                        programa: this.selected[x].programa_id
                        }
                        datos.push(obj)
                    }
                    let alumnos = datos
                    const response = await reportes.restablecerGenerarCargos(alumnos)
                    loading.close()
                    this.$emit('refreshTable')
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Operación con éxito',
                        text: 'Los cargos se han restablecido y generado con éxito'
                    })
                }else {
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Es necesario seleccionar a el/los alumno(s) que quiera realizar la acción',
                    })
                }
            } catch (error) {
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salio mal',
                    text: error.response.data.errores.descripcion
                })
            }
        },
        async getInfoIngreso() {
            const loading = this.$vs.loading()
            try {

                let params = {
                    "institucion": this.institucion,
                    "cicloEscolar": this.cicloEscolar,
                    "type_response": "file"
                }
                if(this.filtros.grupos != ''){
                    params.grupo = this.filtros.grupos
                }
                if(this.filtros.codigosDetalle != ''){
                    params.codigoDetalle = this.filtros.codigosDetalle
                }
                if(this.filtros.fuentesMovimiento != ''){
                    params.fuenteMovimiento = this.filtros.fuentesMovimiento
                }
                if(this.filtros.enTiempos != ''){
                    params.enTiempo = this.filtros.enTiempos
                }
                const response = await reportes.getReporteCargos(params)
                loading.close()
                if(response){
                    window.location.href = response.request.responseURL;
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                }
            }
            catch{
                loading.close()

            }
        },
        getExcel () {
            this.loadingExcel = true
            let formData = {
                'institucion_id': this.institucion,
                'ciclo_escolar_id': this.cicloEscolar
            }
            formData.headers = ['persona_matricula', 'persona_nombre', 'persona_nivel_academico', 'persona_programa', 'ciclo', 'monto', 'concepto', 'fecha_vigencia_aplicacion', 'fuente']
            this.loading = true
            setTimeout(() => {
                axios.get('/reportes/file-cargos', {
                    responseType: 'blob',
                    params: {...formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loading = false;
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
        getFacturado(value){
             if (value.facturado){
                return 'Facturado'
            }else{
                return 'No facturado'
            }
        },
        getColor(status){
            if (status === 'Facturado'){
                return `col-${this.statusColores[status]}`
            }else {
                return `col-${this.statusColores[status]}`
            }
        },
        getColorMetodo(status){
            if (status === false){
                return `col-${this.colorFactura[status]}`
            }else if (status === true){
                return `col-${this.colorFactura[status]}`
            }else if (status === 'cero'){
                return `col-${this.colorFactura[status]}`
            }
        },
        async getProgramas () {
            if (this.institucion && this.cicloEscolar){
                let alumno = []
                this.users.forEach(i => {
                    var obj = {
                        institucion: this.institucion,
                        id: atob(i.estadoCuenta),
                        ciclo_escolar: this.cicloEscolar,
                    }
                    alumno.push(obj)
                })
                // let alumnos = {alumnos: alumno}
                const alumnos = new URLSearchParams();
                let j = 0
                alumno.forEach(i =>{
                    alumnos.append('alumnos[' + j + '][institucion]', i.institucion)
                    alumnos.append('alumnos[' + j + '][id]', i.id)
                    alumnos.append('alumnos[' + j + '][ciclo_escolar]', i.ciclo_escolar)
                    j++
                })
                const response = await reportes.getProgramas(alumnos)
                this.programas = response.data.opciones
            }
        },
        getSeleccionPrograma(){
            let result = []
            this.users.forEach(i => {
            result.push('')
            })
            this.programa = result
        },
        getProgramaAssign(){
            let result = []
            this.users.forEach(i => {
            result.push('')
            })
            this.programaAssign = result
        },
        getVencidas(){
            const vencida = []
            const vencidasIds = []
            this.selected.forEach(i => {
                const datos = Object.values(i.cargos)
                datos.forEach(j => {
                    if(j.fecha.vencida ==  true){
                        this.sendVencida = false
                        if(!vencidasIds.includes(i.persona_id)){
                            vencidasIds.push(i.persona_id)
                            vencida.push(i)
                        }
                    }
                })
            })
            this.vencidas = {
                personas: vencida,
                personas_ids: vencidasIds,
                institucion: this.institucion,
                ciclo_escolar: this.cicloEscolar,
            }
        },
        getActiveModal(tipo){
            this.activeEnviar =! this.activeEnviar
            if(tipo == 'invitacion'){
                this.tipo = {
                    tipo: 'invitacion',
                    texto: 'carta de invitación de pago'
                }
            }
            if(tipo == 'suspencion'){
                this.tipo = {
                    tipo: 'suspencion',
                    texto: 'carta de suspeción'
                }
            }
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
        async getRestablecerCargos  () {
            const loading = this.$vs.loading()
            const vue = this
            let valor = 0
            for(var x = 0;x < vue.selected.length; x++){
                valor += 1
                console.log('this.selected[x]', this.selected[x])
                const valorCargos = Object.values(this.selected[x].cargos)
                const parcializado = valorCargos.map(c => c.fuente == 'Parcializacion de cargos libre')
                const parc = parcializado.includes(true)
                console.log(parc)
                if(!parc){
                    let formData = new FormData();
                    formData.append("id", this.selected[x].persona_id),
                    formData.append("ciclo_escolar", this.cicloEscolar),
                    formData.append("institucion", this.institucion),
                    formData.append("programa", this.selected[x].programa_id)
                    formData.append("nivel_academico", this.nivel)
                    try {
                        const response = await profesor.getRestablecerCargos (formData)
                        if(valor === vue.selected.length){
                            loading.close()
                            vue.$emit('refreshTable')
                            vue.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa'
                            })
                            vue.selected = []
                            vue.allCheck = false
                        }
                    } catch (error) {
                        if(valor === vue.selected.length){
                            vue.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Hubo un problema',
                            })
                            vue.selected = []
                        }
                        loading.close()
                    }
                }else{
                    if(valor === vue.selected.length){
                        loading.close()
                    }
                }
            }
        },

    },
    watch: {
        users(){
            this.selected = []
            this.getNumeroTotal()
            this.getRestaTotal()
        },
        value (val) {
        this.active = val
        this.getProgramas()
        this.getProgramaAssign()
        this.getSeleccionPrograma()
        },
        selected(){
            this.getVencidas()
        }

    }
}
</script>

<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .domicializar .vs-dialog{
        max-width: 95% !important;
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .docientos {
        width: 200px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .vs-avatar img{
        object-fit:contain;
    }
</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

    .cienCincuenta .vs-avatar__badge{
        font-size: 0.9rem !important;
        padding: 3px;
    }

</style>
